import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';
import PermissionButton from './PermissionButton';

interface Props {
    permissions?: string[];
    hasAuthority?: boolean;
    onClick: () => void;
    disabled?: boolean;
    children?: ReactNode;
}

export default function DeleteButton({ permissions, hasAuthority, onClick, disabled, children }: Props) {
    return (
        <PermissionButton
            permissions={permissions}
            hasAuthority={hasAuthority}
            variant="outlined"
            color="error"
            size="small"
            onClick={onClick}
            disabled={disabled}
        >
            {children ?? <FormattedMessage id="delete" />}
        </PermissionButton>
    );
}
